export type ProductionRequestStatus =
  | "pending"
  | "need_more_info"
  | "in_production"
  | "audio_uploaded"
  | "approved"
  | "declined";

export interface ProductionRequest {
  id: number;
  user_id?: number;
  station_id: number;
  what_business_does?: string;
  campaign_goal?: string;
  unique_selling_point?: string;
  call_to_action?: string | null;
  duration?: number;
  status: ProductionRequestStatus;
  created_at: string;
  updated_at?: string;
  station_name?: string;
  user_email?: string;
  message_count?: number;
  audio_count?: number;
  unread_notification_count?: number;
  preview?: string;
}

export interface ProductionRequestFeedback {
  id: number;
  request_id: number;
  audio_id?: number;
  missing_information?: string;
  explanation?: string;
  created_at: string;
}

export interface ProductionRequestMessage {
  id: number;
  request_id: number;
  sender_id: number;
  sender_role: string;
  message: string;
  created_at: string;
}

export type AudioVersionStatus = "waiting_review" | "approved" | "declined";

export interface ProductionRequestAudioVersion {
  id: number;
  request_id: number;
  version: number;
  audio_filepath?: string;
  audio_url?: string;
  uploaded_by?: number;
  created_at: string;
  status?: AudioVersionStatus;
  decline_reason?: string | null;
}

export interface ProductionRequestMoreInfo {
  id: number;
  request_id: number;
  question_text: string;
  reply_text: string | null;
  asked_at: string;
  replied_at: string | null;
  asked_by_user_id: number;
}

export interface ProductionRequestDetail {
  request: ProductionRequest;
  messages: ProductionRequestMessage[];
  more_info_requests?: ProductionRequestMoreInfo[];
  audio_versions: ProductionRequestAudioVersion[];
  feedback?: ProductionRequestFeedback[];
  next_audio_version: number;
}

export const PRODUCTION_REQUEST_STATUS_LABELS: Record<ProductionRequestStatus, string> = {
  pending: "Pending",
  need_more_info: "Need More Info",
  in_production: "In Production",
  audio_uploaded: "Audio Uploaded",
  approved: "Approved",
  declined: "Declined",
};

export const PRODUCTION_REQUEST_STATUS_CLASS: Record<ProductionRequestStatus, string> = {
  pending: "status-pending",
  need_more_info: "status-need-more-info",
  in_production: "status-in-production",
  audio_uploaded: "status-audio-uploaded",
  approved: "status-approved",
  declined: "status-declined",
};

export interface Notification {
  id: number;
  user_id: number;
  /** e.g. production/commercial vs recording — see `notification-deep-link.ts` for bell routing. */
  type: string;
  title: string;
  message: string;
  reference_id: number | null;
  is_read: number;
  created_at: string;
}
